export default "__VITE_ASSET__7d5f70c0__"